import { Dialog, DialogBody, DialogTitle, EditProps } from '@/components/base/dialog'
import { EditTaxRateQuery } from './__generated__/edit_query'
import { Query } from './edit_query'
import { Form as DetailsForm } from './edit_form'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'

export const EditDialog = ({ id, open, setOpen }: EditProps) => {
  const { data, loading } = useQuery<EditTaxRateQuery>(Query, { variables: { filters: { idEq: id } } })

  return (
    <>
      <Dialog open={open} size="5xl" onClose={setOpen}>
        <DialogTitle><div>{ loading || !data ? <Loading /> : data.taxRates.nodes[0].name }</div></DialogTitle>
        <DialogBody>
          <DetailsForm id={id} onSuccess={() => setOpen(false)} />
        </DialogBody>
      </Dialog>
    </>
  )
}
